// モジュール呼び出し
import tab from '../lib/v1ItineraryTab';
import swipe from '../lib/v1ItinerarySwipe';
// IntersectionObserver.prototype.POLL_INTERVAL = 100; // Time in milliseconds.

// spot
export default $target => {
  // ナビ表示制御
  const spotContent = document.getElementById('v1-itinerarySpot');
  const navi = document.querySelector('.v1-itinerarySpot__navi');
  const setNaviVisible = entry => {
    Array.prototype.forEach.call(entry, e => {
      navi.setAttribute('aria-hidden', !e.isIntersecting);
    });
  };
  const option = {
    root: null,
    rootMargin: '-50% 0px',
    threshold: [0.0, 0.75],
  };
  const spotContentObserver = new IntersectionObserver(setNaviVisible, option);
  spotContentObserver.observe(spotContent);

  // ギャラリー
  const naviItem = [].slice.call(document.querySelectorAll('.v1-itinerarySpot__navi-link'));
  const spotArticle = [].slice.call(document.querySelectorAll('.v1-itinerarySpot__spot'));
  let strage = null;

  Array.prototype.forEach.call(spotArticle, article => {
    // tab
    const gallery = tab(article);
    gallery.init();

    // スクロール位置でナビにカレント付与
    const callback = entry => {
      Array.prototype.forEach.call(entry, e => {
        const current = +e.target
          .getAttribute('id')
          .replace(/itinerarySpot/g, '')
          .trim();

        if (strage !== current) {
          if (e.isIntersecting) {
            Array.prototype.forEach.call(naviItem, (n, i) => {
              n.setAttribute('aria-selected', i === current - 1);
            });
          }
          strage = current;
        }
      });
    };
    const observer = new IntersectionObserver(callback, option);
    observer.observe(article);

    // スワイプ操作
    const actSwipe = direction => {
      gallery.changeCurrent(direction ? +1 : -1);
    };
    const ftame = article.querySelector('.v1-itinerarySpot__gallery-current');
    swipe(ftame, actSwipe);
  });

  // img loader
  const images = [].slice.call($target.querySelectorAll('img[data-src]'));
  Array.prototype.forEach.call(images, img => {
    const loadImg = entry => {
      Array.prototype.forEach.call(entry, e => {
        if (e.intersectionRatio === 0) return;
        e.target.src = e.target.dataset.src;  // eslint-disable-line
        imageLoadObserver.unobserve(e.target); // eslint-disable-line
      });
    };
    const imageLoadObserver = new IntersectionObserver(loadImg, {
      root: null,
      rootMargin: '300px 0px',
      threshold: [0],
    });
    imageLoadObserver.observe(img);
  });
};
